import NavLinkGroup from '../../app/components/main-menu/components/nav-link-group/NavLinkGroup';
import UrlsService from '../../../common/router/services/urlsService.mdl';
import useSessionManager from '../../session/hooks/useSessionManager';
import {observer} from 'mobx-react';

export default observer(function ScheduleReportsLinks(): React.JSX.Element {
    const {isUserAllowed} = useSessionManager();
    if (!isUserAllowed('manage:schedule_reports')) {
        return null;
    }

    return (
        <NavLinkGroup label="Schedule Reporting" to={UrlsService.scheduleReports()} iconName="icon-reporting"/>
    );
});
